export default "__VITE_ASSET__2dce3cdb__"